<template>
    <div class="broadcast-list-filters">
        <ds-dropdown
            v-if="!filter.value"
            position="bottom-end"
            disable-scroll
        >
            <ds-text-button leading-icon="filter">
                {{ $options.FILTER_LABEL }}
            </ds-text-button>

            <ul slot="menu" class="dropdown-menu-list">
                <li
                    v-for="({ label, value }, i) in statusFilters"
                    :key="i"
                    :class="['dropdown-menu-item', { selected: isFilterSelected(value) }]"
                    :data-qa="value"
                    @click="handleFilterSelected(value)"
                >
                    {{ label }}
                </li>
            </ul>
        </ds-dropdown>

        <ds-chip
            v-else
            remove
            data-qa="filter-selected"
            with-interaction
            @click.native="handleRemoveFilter"
        >
            <span>{{ filter.label }}</span>
        </ds-chip>
    </div>
</template>

<script>
import { BROADCAST_FILTER_VALUES, BROADCAST_FILTER_LABELS, FILTER_LABEL } from '../constants/emailBroadcast.constants.js';

export default {

    FILTER_LABEL,
    props: {
        filter: {
            type: Object,
            default: () => ({}),
            sync: true,
        },
    },

    data() {
        return {
            statusFilters: [
                { label: BROADCAST_FILTER_LABELS.ALL, value: null },
                { label: BROADCAST_FILTER_LABELS.SENT, value: BROADCAST_FILTER_VALUES.SENT },
                { label: BROADCAST_FILTER_LABELS.SCHEDULED, value: BROADCAST_FILTER_VALUES.SCHEDULED },
                { label: BROADCAST_FILTER_LABELS.DRAFTS, value: BROADCAST_FILTER_VALUES.DRAFT },
            ],
        };
    },

    methods: {
        handleFilterSelected(value) {
            const filter = this.statusFilters.find((f) => f.value === value);

            this.$emit('update:filter', filter);
        },

        handleRemoveFilter() {
            this.handleFilterSelected(null);
        },

        isFilterSelected(value) {
            return this.filter.value === value;
        },
    },
};
</script>
